<template>
  <div class="products-box">
    <div class="section-title">
      <img class="" src="../assets/images/products-title.png" alt="" />
    </div>
    <div class="pro-num">
      “<countTo
                ref="exampleq"
                class="num"
                :startVal="startVal"
                :endVal="8000"
                :duration="3600"
              ></countTo>
              <span class="num">W+</span> 用户 <countTo
                ref="examplew"
                class="num"
                :startVal="startVal"
                :endVal="2200"
                :duration="3600"
              ></countTo><span class="num">+</span> 合作渠道 都在
      <span>博奥教育</span> ”
    </div>
    <div class="products-box">
      <ul>
        <li
          @click="nump = 0"
          class="hvrradialin"
          :class="{ hvrradialout: nump == 0 }"
        >
          项目产品
        </li>
        <!-- <li
          @click="nump = 1"
          class="hvrradialin"
          :class="{ hvrradialout: nump == 1 }"
        >
          公司产品
        </li> -->
        <li
          @click="nump = 1"
          class="hvrradialin"
          :class="{ hvrradialout: nump == 1 }"
        >
          课件资源
        </li>
      </ul>
      <div class="pros-bosx" v-show="nump == 0">
        <div class="pros-list" v-for="(i, index) in types" :key='index' :class="{proslactive:prosnums === index}" @click="typeDucts(index)" >{{i.title}}</div>
      </div>
      <div class="products-bottom">
        <div v-show="nump == 0" class="products-cpxm">
          <div
            class="products-list animate__animated animate__pulse"
            v-for="(item, index) in seList"
            :key="index"
            :class="{ productsactive: item.IndustryType == protype }"
          >
          <Icon class="dropdown" type="md-arrow-dropdown" />
            <div class="products-list-box">
              <div class="ac-products-icon">
                <img :src="item.ProjectIcon" alt="" />
                <h3>{{ item.Name }}</h3>
              </div>
              <div class="ho-products-icon">
                <h4>{{ item.Name }}</h4>
                <!-- <p>{{ item.text }}</p> -->
                <img :src="item.GzhUrl" alt="" />
                <div style="color:#B00000;text-decoration: underline;" @click="lookProducts(item.IndustryType,item.Id)">查看详情</div>
              </div>
            </div>
          </div>
          <div class="more-btn animate__animated animate__pulse" @click="morProducts">
            <div class="glowbtn__glow"></div>
            <div class="glowbtn__text">了解更多</div>
          </div>
        </div>
        <!-- <div v-show="nump == 1">
          <div class="cp-main animate__animated animate__pulse">
            <div class="cp-box">
              <img class="box-img" src="../assets/images/ipec-f.png" alt="" />
              <img
                class="look-btn"
                @click="OpIpecModal(1)"
                src="../assets/images/look-btn.png"
                alt=""
                srcset=""
              />
            </div>
            <div class="cp-box">
              <img class="box-img" src="../assets/images/ihec-f.png" alt="" />
              <img
                class="look-btn"
                @click="OpIpecModal(2)"
                src="../assets/images/look-btn.png"
                alt=""
                srcset=""
              />
            </div>
          </div>

        </div> -->
        <div v-show="nump == 1">
<div class="soul-rightbox animate__animated animate__fadeInUp">
            <div class="swiper-pagination soul-rightbox-lf"></div>
            <div class="soul-rightbox-ri">
            <swiper :options="solution" ref="mySwiper">
              <swiper-slide v-for="(item, index) in solutiondata" :key="index">
                <div>
                  <img :src="item.imgUrl" alt="">
                </div>
              </swiper-slide>

            </swiper>

          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Modal
      v-model="IpecModal"
      title="IPEC"
      :styles="{ width: '800px', height: '500px' }"
    >
      <p slot="header">
        <span>{{ videtype == 1 ? "智能课件系统" : "智能AI家考系统" }}</span>
      </p>

      <div style="text-align: center">
        <div id="test"></div>
      </div>

      <div slot="footer"></div>
    </Modal> -->
  </div>
</template>

<script>
// import { videoPlayer } from "vue-video-player";
import countTo from 'vue-count-to'
import 'video.js/dist/video-js.css'
var text
export default {
  components: {
    // videoPlayer,
    countTo
  },
  data () {
    return {
      nump: 0,
      videtype: 0,
      protype: 0,
      startVal: 0,
      prosnums: 0,
      liveList: [],
      trafficList: [],
      fdaList: [],
      medList: [],
      seList: [],
      types: [
        { title: '全部行业', id: 0 },
        { title: '住房城乡建设行业', id: 1 },
        { title: '交通运输行业', id: 2 },
        { title: '食品安全行业', id: 3 },
        { title: '医疗卫生行业', id: 4 }
      ],
      productslist: [
        {
          id: 1,
          type: '住房城乡建设行业',
          title: '住房城乡建设行业从业人员培训管理信息系统',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/logo-1.jpg'),
          imgUrlCode: require('../assets/images/wxcode/code-1.png')
        },
        {
          id: 1,
          type: '住房城乡建设行业',
          title: '住房城乡建设行业从业人员教育培训资源库',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/logo-2.png'),
          imgUrlCode: require('../assets/images/wxcode/code-1.png')
        },
        {
          id: 1,
          type: '住房城乡建设行业',
          title: '住房城乡建设领域BIM应用专业技能培训考试综合服务平台',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/logo-3.png'),
          imgUrlCode: require('../assets/images/wxcode/code-3.png')
        },
        {
          id: 2,
          type: '交通运输行业',
          title: '全国道路运输驾驶员继续教育网络平台',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/ic_launcher.png'),
          imgUrlCode: require('../assets/images/wxcode/code-9.png')
        },
        {
          id: 2,
          type: '交通运输行业',
          title: '交通运输企业安全教育公共服务系统',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/zsaq.png'),
          imgUrlCode: require('../assets/images/wxcode/code-9.png')
        },
        {
          id: 3,
          type: '食品安全行业',
          title: '食品安全宣传教育与抽查考核服务平台',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/logo-4.png'),
          imgUrlCode: require('../assets/images/wxcode/code-4.png')
        },
        {
          id: 3,
          type: '食品安全行业',
          title: '食品安全管理人员考核服务平台',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/logo-5.png'),
          imgUrlCode: require('../assets/images/wxcode/code-4.png')
        },
        {
          id: 3,
          type: '食品安全行业',
          title: '特殊食品抽查考核管理系统',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/tslogo.png'),
          imgUrlCode: require('../assets/images/wxcode/code-4.png')
        },
        {
          id: 4,
          type: '医疗卫生行业',
          title: '母婴健康指导师培训考核综合服务平台',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/muying-logo.png'),
          imgUrlCode: require('../assets/images/wxcode/code-10.jpg')
        },
        {
          id: 4,
          type: '医疗卫生行业',
          title: '托育服务从业人员培训管理信息系统',
          text: '简介',
          imgUrl: require('../assets/images/wxcode/toyu-logo.png'),
          imgUrlCode: require('../assets/images/wxcode/code-11.jpg')
        }
      ],
      IpecModal: false,

      list: [
        '1CBA6D32660DE4382BBA984E86119800 ',
        '8B7C7052AB46BE3FFC9558351D509E7C'
      ],
      idx: 0,
      solution: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 10,
        mousewheel: true,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            switch (index) {
              case 0:text = '高清互动屏授课'; break
              case 1:text = '虚拟演播室'; break
              case 2:text = '实景拍摄'; break
              case 3:text = '图文互动'; break
              case 4:text = '宣传片'; break
              case 5:text = 'MG动画'; break
              case 6:text = '三维动画'; break
              case 7:text = 'IPEC智能课件'; break
            }
            return '<div class="' + className + '"><div class="timeline-item-tail"></div><div class="text">' + text + '</div><span class="dian"></span></div>'
          }
        }
      },
      solutiondata: [
        {
          id: 0,
          title: '高清互动屏授课',
          text: 'ss',
          imgUrl: require('../assets/images/soul-list1.png')
        },
        {
          id: 1,
          title: '实景拍摄',
          text: 'ss',
          imgUrl: require('../assets/images/soul-list2.png')
        },
        {
          id: 2,
          title: '图文互动',
          text: 'ss',
          imgUrl: require('../assets/images/soul-list3.png')
        },
        {
          id: 3,
          title: '三维动画',
          text: 'ss',
          imgUrl: require('../assets/images/soul-list4.png')
        },
        {
          id: 4,
          title: 'MG动画',
          text: 'ss',
          imgUrl: require('../assets/images/soul-list5.png')
        },
        {
          id: 5,
          title: '虚拟演播室',
          text: 'ss',
          imgUrl: require('../assets/images/soul-list6.png')
        },
        {
          id: 6,
          title: '宣传片',
          text: 'ss',
          imgUrl: require('../assets/images/soul-list7.png')
        },
        {
          id: 7,
          title: 'IPEC智能课件',
          text: 'ss',
          imgUrl: require('../assets/images/ipec.png')
        }
      ]
    }
  },
  methods: {
    getProList () {
      let that = this
      this.axios({
        methods: 'GET',
        url: '/api/ProductSys/GetProducts'
      })
        .then(result => {
          // console.log(result, 'result')
          if (result.data.success) {
            let arr = result.data.data
            that.list = arr
            arr.forEach(function (item, index) {
              if (item.IndustryType == 1) {
                if (that.liveList.length < 3) {
                  that.liveList.push(item)
                  that.seList.push(item)
                }
              } else if (item.IndustryType == 2) {
                if (that.trafficList.length < 2) {
                  that.trafficList.push(item)
                  that.seList.push(item)
                }
              } else if (item.IndustryType == 3) {
                if (that.fdaList.length < 3) {
                  that.fdaList.push(item)
                  that.seList.push(item)
                }
              } else if (item.IndustryType == 4) {
                if (that.medList.length < 2) {
                  that.medList.push(item)
                  that.seList.push(item)
                }
              }
            })
            // that.seList.push(that.liveList)
            // that.seList.push(that.trafficList)
            // that.seList.push(that.fdaList)
            // that.seList.push(that.medList)
            // console.log(that.seList, 'that.seList')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // OpIpecModal(type) {
    //   this.videtype = type;
    //   this.idx = type - 1;
    //   this.IpecModal = true;

    //   if (window.ccH5PlayerJsLoaded) {
    //     this.createPlayer();
    //   }
    // },

    // createPlayer() {
    //   this.test = document.getElementById("test");
    //   if (this.idx >= this.list.length) this.idx = 0;
    //   this.player = window.createCCH5Player({
    //     vid: this.list[this.idx],
    //     siteid: "91C21EF3AD3F9C3A",
    //     autoStart: true,
    //     width: "100%",
    //     height: "400px",

    //     //    'width': "500px",
    //     // 'height': "400px",

    //     mediatype: 1,
    //     playtype: 1,
    //     autoStart: true,
    //     realAutoPlay: true,
    //     // 'watchStartTime': tmpStudyLastTime,
    //     closeHistoryTime: 1, //设置是否关闭记忆播放功能。0，使用； 1，关闭
    //     defaultDf: 10, // 参数配置10（标清）
    //     // 'progressbar_enable': study.isAllowedFast ? 1 : 0,//为0时禁止进度拖动，为1时允许拖动快进退
    //     rate_allow_change: false, //是否允许切换倍速
    //     isShare: false,
    //     showHdBtn: false, //默认 true 为false时不显示按钮
    //     loop: false, //是否循环播放

    //     parentNode: this.test,
    //   });
    // },
    // nextPlayer() {
    //   this.player && this.player.destroy();
    //   this.createPlayer();
    // },
    // setPlayerCallBack() {
    //   window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
    //   window.on_CCH5player_ready = this.onPlayerReady;
    //   window.on_player_volumechange = this.onPlayerVolumeChange;
    // },
    // onCCH5PlayerLoaded() {
    //   window.ccH5PlayerJsLoaded = true;
    //   this.createPlayer();
    // },
    // onPlayerReady(obj) {
    //   // console.log("CCH5player_ready", obj);
    //   window.cc_js_Player.setVolume(0.3);
    // },
    // onPlayerVolumeChange(volume, vid) {
    //   // console.log("设置音量回调:  ", volume, vid);
    // },
    pronum () {
      this.$refs.exampleq.start()
      this.$refs.examplew.start()
    },
    typeDucts (index) {
      this.protype = index
      this.prosnums = index
      // console.log(index, this.protype, 'sds')
    },
    morProducts () {
      this.$router.push({
        path: '/proproducts'
      })
    },
    lookProducts (typeId, index) {
      this.$router.push({
        path: '/proproducts',
        query: {
          type: typeId,
          id: index
        }
      })
    }
  },
  created () {
    // this.setPlayerCallBack();
  },
  mounted () {
    this.getProList()
    // if(window.ccH5PlayerJsLoaded) {
    // 	this.createPlayer();
    // }
  },
  destroyed () {
    // this.player && this.player.destroy();
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/productsView.vue